/**
 * \@docs-private
 * @param {?} provider
 * @return {?}
 */
export function createMissingDateImplError(provider) {
    return Error("MatDatepicker: No provider found for " + provider + ". You must import one of the following " +
        "modules at your application root: MatNativeDateModule, or provide a custom implementation.");
}
//# sourceMappingURL=datepicker-errors.js.map